module.exports = __webpack_public_path__ + "assets/img/Label.d2c35481.png";